<template>
    <section class="contract-section">
        <div class="module-content">
            <div class="content">
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="button-body"
                    >
                        Perfil
                    </p>
                </div>

                <h1 class="title-content heading-4">
                    Contrato de arrendamento
                </h1>

                <div class="contract-description-wraper">
                    <p class="color-text-body">
                        Este contrato representa o compromisso assumido de forma
                        simples e segura entre as partes. Agradecemos a sua
                        confiança e preferência.
                    </p>

                    <p class="color-text-body">
                        Tem à sua disposição a possibilidade de descarregar o
                        contrato ou de o receber de forma prática no seu email.
                    </p>

                    <div class="support-info">
                        <p class="color-text-body">
                            Caso precise de entrar em contacto connosco,
                            providêncie estas informações:
                        </p>

                        <p class="color-text-body">
                            <strong>ID do contrato:</strong> {{ contract.id }}
                        </p>
                        <p class="color-text-body">
                            <strong>Nome do contrato:</strong>
                            {{ contract.data.filealt }}
                        </p>
                        <p class="color-text-body">
                            <strong>Data de criação:</strong>
                            {{ contract.created_at }}
                        </p>
                    </div>
                </div>

                <a
                    :href="`${contracturl}/${contract.data.filenamenew}`"
                    class="btn btn-primary btn-filled-blue"
                    target="_self"
                    :download="`${contract.data.filealt
                        .toLowerCase()
                        .replace(' ', '_')}.${contract.data.fileext}`"
                >
                    <p class="color-white">Guardar contrato</p>
                </a>

                <div class="or-create-account-hr">
                    <div class="line"></div>
                    <p class="color-text-body">ou</p>
                    <div class="line"></div>
                </div>

                <button
                    class="btn btn-primary btn-filled-white send-email-btn"
                    role="button"
                    @click="sendData()"
                    :disabled="disabled"
                >
                    <p class="color-text-action">Enviar cópia por email</p>
                </button>
            </div>
        </div>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>
<script>
import TableElement from "./../../../elements/TableElement.vue";
import defaultWebsite from "./../../../../defaultWebsiteScript.js";
import fetchData from "./../../../../fetchData.js";
import ListMessage from "./../../../elements/ListMessageElement.vue";
import Loading from "./../../../elements/LoadingElement.vue";
import responseMessage from "./../../../../responseMessage";

//Set Use Strict
("use strict");

export default {
    name: "ProfessionalContract",
    props: {
        contractdata: {
            type: String,
            required: true,
        },
        contracturl: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
        sendmailurl: {
            type: String,
            required: true,
        },
        csrftolken: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            contract: {},
            activeclass: "d-flex",
            disabled: false,
        };
    },
    created() {
        this.contract = JSON.parse(this.contractdata);
        this.contract.data = JSON.parse(this.contract.data);
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        sendData() {
            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Data Form
            let dataForm = {
                contract: this.contract,
            };

            //Send Data
            let response = fetchData.structureTosendData(
                this.sendmailurl,
                dataForm,
                this.csrftolken,
                "POST"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass
                    );

                    //Enabled Button
                    this.disabled = false;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    components: {
        tableElement: TableElement,
        listMessage: ListMessage,
        loading: Loading,
    },
};
</script>
